import { render } from "./App.vue?vue&type=template&id=63d3d37e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=63d3d37e&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__